import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

export default class extends Controller {
  static targets = ["warehouse", "search", "row", "checkbox", "count", "modalCount", "empty", "selectedItem", "selectedEmpty", "modal"]

  connect() {
    this.committedIds = this.selectedIds()
    this.filter()
    this.renderSelection()
  }

  changeWarehouse() {
    const warehouseId = this.warehouseTarget.value
    if (warehouseId) {
      this.rowTargets.forEach((row) => {
        if (row.dataset.warehouseId !== warehouseId) {
          row.querySelector("input[type='checkbox']").checked = false
        }
      })
    }
    this.committedIds = this.selectedIds()
    this.filter()
    this.renderSelection()
  }

  startSelection() {
    this.applied = false
    this.searchTarget.value = ""
    this.filter()
    this.refreshOptions()
  }

  discardSelection() {
    if (!this.applied) {
      this.checkboxTargets.forEach((checkbox) => {
        checkbox.checked = this.committedIds.includes(checkbox.value)
      })
      this.refreshOptions()
    }
    this.applied = false
  }

  applySelection() {
    this.committedIds = this.selectedIds()
    this.applied = true
    this.renderSelection()
    Modal.getOrCreateInstance(this.modalTarget).hide()
  }

  remove(event) {
    const vehicleId = event.currentTarget.dataset.vehicleId
    const checkbox = this.checkboxTargets.find((item) => item.value === vehicleId)
    if (!checkbox) return

    checkbox.checked = false
    this.committedIds = this.selectedIds()
    this.renderSelection()
  }

  selectionChanged() {
    this.refreshOptions()
  }

  preventSearchSubmit(event) {
    event.preventDefault()
  }

  filter() {
    const query = this.searchTarget.value.trim().toLocaleLowerCase("pt-BR")
    const warehouseId = this.warehouseTarget.value
    let visible = 0

    this.rowTargets.forEach((row) => {
      const matches = (!warehouseId || row.dataset.warehouseId === warehouseId) &&
        (!query || row.dataset.searchText.includes(query))
      row.classList.toggle("d-none", !matches)
      if (matches) visible += 1
    })

    this.emptyTarget.classList.toggle("d-none", visible > 0)
  }

  selectedIds() {
    return this.checkboxTargets.filter((checkbox) => checkbox.checked).map((checkbox) => checkbox.value)
  }

  refreshOptions() {
    const count = this.selectedIds().length
    this.modalCountTarget.textContent = `${count} ${count === 1 ? "selecionado" : "selecionados"}`
    this.rowTargets.forEach((row) => {
      const selected = row.querySelector("input[type='checkbox']").checked
      const unavailable = row.querySelector("input[type='checkbox']").disabled
      row.classList.toggle("border-primary", selected)
      row.classList.toggle("bg-light", selected)
      const badge = row.querySelector("[data-selection-label]")
      badge.textContent = unavailable ? (row.dataset.unavailableLabel || "Indisponível") : (selected ? "Selecionado" : "Selecionar")
      badge.classList.toggle("text-bg-primary", selected && !unavailable)
      badge.classList.toggle("text-bg-light", !selected && !unavailable)
      badge.classList.toggle("text-bg-warning", unavailable)
      badge.classList.toggle("border", !selected && !unavailable)
    })
  }

  renderSelection() {
    const count = this.committedIds.length
    this.countTarget.textContent = `${count} ${count === 1 ? "selecionado" : "selecionados"}`
    this.selectedEmptyTarget.classList.toggle("d-none", count > 0)
    this.selectedItemTargets.forEach((item) => {
      item.classList.toggle("d-none", !this.committedIds.includes(item.dataset.vehicleId))
    })
    this.refreshOptions()
  }
}
